import BalanceSlider from './BalanceSlider';

export default BalanceSlider;
